import { SpecializationDto } from "../../../../Api/Model/SpecializationDto.csharp";
import { ServiceDto } from "../../../../Api/Model/ServiceDto.csharp";
import { useEffect, useState } from "react";
import { LocationDto } from "../../../../Api/Model/LocationDto.csharp";
import { DoctorDto } from "../../../../Api/Model/DoctorDto.csharp";
import { haveCommonElements } from "../Helpers";
import { ServiceGroupDto } from "@apiModels/ServiceGroupDto.csharp";

export const useFilteredLocations = (
  locations: LocationDto[],
  specialization: SpecializationDto,
  service: ServiceDto,
  selectedServiceGroup: ServiceGroupDto,
  forcedDoctor?: DoctorDto
) => {
  const [filteredItems, setFilteredItems] = useState<LocationDto[]>([]);
  const [otherItems, setOtherItems] = useState<LocationDto[]>([]);

  useEffect(() => {
    const getSupportedLocationsIds = () => {
      if (service.id) {
        return service.centerBookingOptions.map((center) => center.centerId);
      }
      if (servicesOfSelectedServiceGroup.length > 0) {
        return servicesOfSelectedServiceGroup.map((service) =>
          service.centerBookingOptions
            .map((center) => center.centerId)
            .reduce((a, b) => a.concat(b))
        );
      }
      return [];
    };

    let filteredLocations = locations.filter((location) => {
      if (location.excludeFromListings) {
        if (!service.id) {
          return false;
        }
        return location.specializations.some(
          (specializationId) => service.specializationId === specializationId
        );
      }
      return true;
    });

    const servicesOfSelectedServiceGroup = selectedServiceGroup?.services
      ? [...selectedServiceGroup.services]
      : [];

    if (specialization.id) {
      filteredLocations = filteredLocations.filter((loc) =>
        loc.specializations.includes(specialization.id)
      );
    }

    if (service.id || servicesOfSelectedServiceGroup.length > 0) {
      const supportedLocationsIds = getSupportedLocationsIds();
      filteredLocations = filteredLocations.filter((loc) => {
        if (loc.isLocation === false) {
          return supportedLocationsIds.includes(loc.id);
        }
        return loc.centers.some((lc) => supportedLocationsIds.includes(lc));
      });
    }

    if (forcedDoctor) {
      filteredLocations = filteredLocations.filter(
        (loc) =>
          (loc.isLocation &&
            haveCommonElements(loc.centers, forcedDoctor.centers)) ||
          forcedDoctor.centers.indexOf(loc.id) != -1
      );
    }

    setFilteredItems(filteredLocations);

    if (specialization.id && service.id) {
      const unavailable = locations
        .filter((l) => l.specializations.includes(specialization.id))
        .filter((l) => !l.excludeFromListings)
        .filter(
          (l) =>
            service.centerBookingOptions.some((cbo) => cbo.centerId == l.id) ==
            false
        )
        .filter((l) => l.isLocation == false);
      setOtherItems(unavailable);
    } else if (specialization.id && selectedServiceGroup.id) {
      let supportedLocationsId: string[] = [];
      servicesOfSelectedServiceGroup.map((service) =>
        service.centerBookingOptions.map((center) =>
          supportedLocationsId.push(center.centerId)
        )
      );
      const unavailable = locations
        .filter((l) => l.specializations.includes(specialization.id))
        .filter(
          (l) => supportedLocationsId.some((locId) => locId == l.id) == false
        )
        .filter((l) => l.isLocation == false);
      setOtherItems(unavailable);
    } else {
      const unavailable = filteredLocations
        .filter((l) => filteredLocations.indexOf(l) == -1)
        .filter((l) => l.isLocation == false);
      setOtherItems(unavailable);
    }
  }, [specialization, service, forcedDoctor]);

  return {
    filteredLocations: filteredItems,
    unavailableLocations: otherItems,
  };
};
